var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadge({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.828,
    height: 27.709,
    viewBox: "0 0 19.828 27.709",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "badge",
    transform: "translate(-34.662 -23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_181460",
    "data-name": "Path 181460",
    d: "M72.993,77.66l-3.52-1.937-1.587,3.692-2.6-7.549-.38-1.1L64,68.115l5.106-1.758.816,2.38.357,1.038Z",
    transform: "translate(-19.424 -28.706)",
    fill: "#ef5261"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181461",
    "data-name": "Path 181461",
    d: "M46.38,68.115l-.909,2.648-.38,1.1-2.6,7.549-1.587-3.692-3.52,1.937L40.1,69.768l.354-1.031.819-2.38Z",
    transform: "translate(-1.804 -28.706)",
    fill: "#ef5261"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181462",
    "data-name": "Path 181462",
    d: "M57.978,69.775c-.188-.013-.373-.04-.555-.066-.119-.017-.245-.034-.35-.043-.03.106-.063.235-.089.334a2.232,2.232,0,0,1-1.11,1.7,1.457,1.457,0,0,1-.549.106,2.861,2.861,0,0,1-1.419-.522c-.093-.053-.208-.122-.311-.175-.068.082-.145.185-.2.264a5.526,5.526,0,0,1-.4.492l-.382-1.1c-.288.38-.579.773-.909.773s-.621-.393-.909-.773l-.38,1.1a5.525,5.525,0,0,1-.4-.5c-.059-.079-.135-.182-.2-.264-.1.053-.218.122-.311.175a2.86,2.86,0,0,1-1.419.522,1.457,1.457,0,0,1-.549-.106,2.223,2.223,0,0,1-1.11-1.7c-.026-.1-.059-.228-.093-.338-.1.01-.228.03-.347.046-.182.023-.367.049-.555.059l.353-1.029.819-2.38L51.7,68.116,56.8,66.359l.816,2.379Z",
    transform: "translate(-7.123 -28.707)",
    fill: "#da364c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181463",
    "data-name": "Path 181463",
    d: "M53.007,34.594c-.122.6.962,1.563.731,2.118s-1.679.476-2.016.98.294,1.808-.135,2.238c-.212.212-.645.162-1.087.1a1.865,1.865,0,0,0-1.149.034c-.5.334-.413,1.781-.98,2.016-.552.228-1.514-.853-2.115-.734-.27.056-.519.377-.77.71-.288.38-.579.773-.909.773s-.621-.393-.909-.773c-.251-.334-.5-.655-.77-.71-.6-.119-1.563.962-2.115.734S40.3,40.4,39.8,40.062a1.854,1.854,0,0,0-1.149-.03c-.439.059-.873.109-1.084-.1-.429-.43.2-1.735-.135-2.238s-1.785-.416-2.016-.98.853-1.517.731-2.118c-.113-.585-1.484-1.061-1.484-1.679s1.372-1.094,1.484-1.676c.122-.6-.962-1.567-.731-2.118s1.679-.479,2.016-.978-.294-1.811.135-2.238,1.732.2,2.238-.135.413-1.781.978-2.016,1.514.853,2.115.734c.584-.117,1.06-1.488,1.678-1.488s1.094,1.372,1.679,1.487c.6.119,1.563-.962,2.115-.734s.479,1.682.982,2.016,1.808-.291,2.234.135-.2,1.732.135,2.238,1.785.413,2.016.978-.853,1.517-.731,2.118c.113.582,1.484,1.058,1.484,1.676s-1.371,1.095-1.484,1.679Z",
    fill: "#f6c863"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_181464",
    "data-name": "Path 181464",
    d: "M51.156,46.054A6.556,6.556,0,1,1,57.711,39.5,6.556,6.556,0,0,1,51.156,46.054Zm0-12.325a5.77,5.77,0,1,0,5.77,5.77A5.77,5.77,0,0,0,51.156,33.729Z",
    transform: "translate(-6.58 -6.583)",
    fill: "#eab54e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.c451cff1bfa7c8be10c582b4ef3dbd5c.svg";
export { ForwardRef as ReactComponent };